import React, { useState } from "react";

import { useTranslation } from "utils";

import { appVersions } from "enums";

import { Flex, MainPage, Svg, Typography } from "components";

interface ShareData {
  title: string;
  summary: string;
  link: string;
  image: string;
}

export const Verifying = () => {
  const { t } = useTranslation("meta");

  const [share] = useState<ShareData>({
    title: t("meta:verifying.title"),
    summary: t("meta:verifying.description"),
    link: `${process.env.REACT_APP_FARM_URL}/sign-up`,
    image: `${process.env.REACT_APP_FARM_URL}/images/misc/share.png`,
  });

  return (
    <MainPage pageName={"splash"} share={share}>
      <section>
        <Flex vertical align="center" justify="flex-end" gap={16} className="full-height">
          <Svg svgName="logos/klim_logo_brandmark_and_text_white" className="pulsating" />
          {/* Bottom page-edge offset; there is no sibling to express it as a gap */}
          <Typography variant="paragraph-m" color="grey-600" className="margin-bottom-500">
            v{appVersions[0].major}.{appVersions[0].minor}
          </Typography>
        </Flex>
      </section>
    </MainPage>
  );
};
